import * as Device from "expo-device";
import { Platform } from "react-native";

export const APPLE_PAY_AVAILABLE = Platform.OS === "ios" && Device.isDevice;
